import { render, staticRenderFns } from "./bill-detail.vue?vue&type=template&id=53e065ec"
import script from "./bill-detail.vue?vue&type=script&lang=js"
export * from "./bill-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports